import React, { useRef } from 'react';
import {
  Box,
  Textarea,
  Heading,
  FormControl,
  FormLabel,
  useTheme,
} from '@chakra-ui/react';
import { useAutoResize } from '../../hooks/util';

const PromptConfig = ({
  systemPrompt,
  forceDisable,
  template,
  updatePrompt,
}) => {
  const sysPromptRef = useRef(null);
  const templateRef = useRef(null);
  const theme = useTheme();

  useAutoResize(sysPromptRef);
  useAutoResize(templateRef);

  return (
    <Box p={4} maxW={800}>
      {/* <Heading as="h3" size="md">{title}</Heading> */}
      <FormControl id='prompt'>
        <FormLabel>System Prompt</FormLabel>
        <Textarea
          background={theme.colors.bgGrey2}
          value={systemPrompt}
          onChange={updatePrompt}
          ref={sysPromptRef}
          style={{ overflow: 'hidden' }}
          resize={'none'}
          disabled={forceDisable}
        />
      </FormControl>
      <FormControl id='template' mt={5}>
        <FormLabel>Template</FormLabel>
        <Textarea
          background={theme.colors.bgGrey2}
          value={template}
          ref={templateRef}
          style={{ overflow: 'hidden' }}
          resize={'none'}
          disabled
        />
      </FormControl>
    </Box>
  );
};

export default PromptConfig;
